export default {
  total: 'Total',
  projects: 'Projects',
  hours: 'Hours',
  totalSpend: 'Total Spend',
  anticipatedRevenue: 'Anticipated Revenue',
};
